import { PhoneNumberInputSchema, dateTextInputSchema } from '@aspendental/shared-forms-web';
import { mountStoreDevtool } from 'simple-zustand-devtools';
import z from 'zod';
import { create } from 'zustand';

import { emailSchema, nameSchema, zipCodeSchema } from '@src/utils/shared-schemas';

type State = {
	required: boolean;
	firstName: string;
	lastName: string;
	dateOfBirth: Date | null;
	zipCode: string;
	email: string;
	phoneNumber: string;
	relationshipToPatient: string;
};

type Actions = {
	setRequired: (input: boolean) => void;
	setFirstName: (input: string) => void;
	setLastName: (input: string) => void;
	setDateOfBirth: (input: Date) => void;
	setZipCode: (input: string) => void;
	setEmail: (input: string) => void;
	setPhoneNumber: (input: string) => void;
	setRelationshipToPatient: (input: string) => void;
};

export const StateSchema = {
	firstName: nameSchema,
	lastName: nameSchema,
	dateOfBirth: dateTextInputSchema.options.patientAge,
	zipCode: zipCodeSchema.required,
	email: emailSchema,
	phoneNumber: PhoneNumberInputSchema.options.default,
	relationshipToPatient: z.string(),
};

const useGuarantorInformationFormStore = create<State & Actions>((set) => ({
	required: false,
	firstName: '',
	lastName: '',
	dateOfBirth: null,
	zipCode: '',
	email: '',
	phoneNumber: '',
	relationshipToPatient: '',
	setRequired: (input: boolean) => {
		set({ required: input });
	},
	setFirstName: (input: string) => {
		set({ firstName: input.trim() });
	},
	setLastName: (input: string) => {
		set({ lastName: input.trim() });
	},
	setDateOfBirth: (input: Date) => {
		set({ dateOfBirth: input });
	},
	setZipCode: (input: string) => {
		set({ zipCode: input });
	},
	setEmail: (input: string) => {
		set({ email: input });
	},
	setPhoneNumber: (input: string) => {
		set({ phoneNumber: input });
	},
	setRelationshipToPatient: (input: string) => {
		set({ relationshipToPatient: input });
	},
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('guarantorInformationFormStore', useGuarantorInformationFormStore);
}

export default useGuarantorInformationFormStore;
